import { Component, Host, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';
import { SharedFormService } from '../../services/shared-form.service';
import { SchedaMorteComponent } from '../../scheda-morte/scheda-morte.component';
import { SwitchModalitaService } from '../../services/switch-modalita.service';
import { distinctUntilChanged, first } from 'rxjs';


@Component({
  selector: 'app-anagrafica',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, NgIf, NgClass],
  templateUrl: './anagrafica.component.html',
  styleUrl: './anagrafica.component.scss'
})
export class AnagraficaComponent {

  form = this.sharedFormService.form.get('anagraficaForm') as FormGroup;
  public inputDisattivati: boolean = false;
  public inModifica: boolean = false;
  @Input() schedaMorte!: any;

  ngOnInit() {
  }

  ngAfterViewInit() {
    if(!this.schedaMorte.modalita && !this.schedaMorte.giaInModifica){
      console.log(this.schedaMorte.modalita)
      console.log(this.schedaMorte.giaInModifica)
      this.form.disable();
    }
    else{
      this.form.enable();
    }
    this.schedaMorte.modificaSubject.pipe(first()).subscribe((modifica: boolean) => {
      if(modifica){
        this.form.enable();
      }
    });
  }
  

  invalidBorder(form: string) {
    if ((this.form.get(form)?.invalid && this.form.get(form)?.touched) || (this.form.get(form)?.invalid && this.schedaMorte.attivaBordi)) {
      return true;
    }
    return false;
  }



  maxLengthInput(event: any, maxLength: number): boolean {
    const input = event.target as HTMLInputElement;
    const isBackspace = event.key === 'Backspace';
    const isTab = event.key === 'Tab';

    if (input.value.length === maxLength && !isBackspace && !isTab) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  limitInput(input: EventTarget | null, maxLength: number) {
    const inputElement = input as HTMLInputElement;
    if (inputElement && inputElement.value.length > maxLength) {
      inputElement.value = inputElement.value.slice(0, maxLength);
    }
  }
  

  

  constructor(private formBuilder: FormBuilder, private sharedFormService: SharedFormService, private switchModalita: SwitchModalitaService) { }
}
